jQuery(function($){
    $('.related-products-slider').on('afterChange', function(slick, currentSlide){
        scaleBgImages();
    });
    $('.related-products-slider').slick({
        dots: false,
        arrows: true,
        prevArrow: '<div class="slick-prev slider-prev slider-arrow"><svg class="icon"><use xlink:href="#left-angle" /></svg></div>',
        nextArrow: '<div class="slick-next slider-next slider-arrow"><svg class="icon"><use xlink:href="#right-angle" /></svg></div>',
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
              breakpoint: 768,
              settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
              }
          },
          {
              breakpoint: 600,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
              }
          }
        ]
    });
})